import styled, { css } from 'styled-components';
import { Box, Text } from '@rsos/components/capstone/base';

const CHAT_HEADER_HEIGHT = 60; // Matches the constant in ASCChatBox.styles.js

export const chatHeaderIconColor = 'secondaryText';

export const unreadBar = css`
  content: '';
  position: absolute;
  overflow: hidden;
  top: 0;
  left: 0;
  width: 5px;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.primaryBase};
`;

export const UnreadPill = styled(Box).attrs({
  align: 'center',
  justify: 'center',
  height: '18px',
  marginRight: '12px',
  padding: '0 8px',
  backgroundColor: 'primaryBase',
})`
  border-radius: 9px;
  color: ${({ theme }) => theme.colors.background};
  font-size: 12px;
  line-height: 1;
`;

export const Container = styled(Box).attrs({
  position: 'relative',
  horizontal: true,
  align: 'center',
  width: '100%',
  height: CHAT_HEADER_HEIGHT,
  minHeight: CHAT_HEADER_HEIGHT,
  padding: '15px 12px',
  backgroundColor: 'background',
})`
  border-bottom: ${({ isChatBoxVisible, theme }) =>
    !isChatBoxVisible ? '0' : `1px solid ${theme.colors.lightLineDivider}`};
  border-radius: ${({ isChatBoxVisible }) =>
    isChatBoxVisible ? '5px 5px 0 0' : '5px'};
  &:before {
    ${({ isUnread }) => isUnread && unreadBar};
  }
`;

export const AvatarBox = styled(Box).attrs({
  flex: '0 0 auto',
})``;

export const AgencyInfo = styled(Box).attrs({
  flex: '1 1 auto',
  marginX: '12px',
  overflow: 'hidden',
})``;

export const AgencyName = styled(Text).attrs({
  color: 'primaryText',
  size: 'small',
  fontWeight: 'bold',
  ellipsis: true,
})``;

export const AgencyPhone = styled(Box).attrs({
  horizontal: true,
  minHeight: '12px',
  align: 'center',
  marginTop: '2px',
})`
  color: ${({ theme }) => theme.colors.primaryText};
  font-size: 12px;
  line-height: 1.2;
`;

export const PhoneNumber = styled(Text).attrs({
  inline: true,
  marginLeft: '5px',
  color: 'secondaryText',
  size: 'small',
})``;

export const AgenciesTitle = styled.span`
  color: ${({ theme }) => theme.colors.primaryText};
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
`;

export const AgenciesList = styled.span`
  color: ${({ theme }) => theme.colors.primaryText};
  font-size: 12px;
  line-height: 1.2;
`;

export const ActionsBox = styled(Box).attrs({
  position: 'relative',
  horizontal: true,
  align: 'center',
  flex: '0 0 auto',
})``;

export const ActionButton = styled(Box).attrs(({ noMargin }) => ({
  align: 'center',
  justify: 'center',
  width: '24px',
  height: '24px',
  marginRight: noMargin ? 0 : '5px',
  backgroundColor: 'background',
}))`
  ${({ showBorder, theme }) =>
    showBorder && `border: 1px solid ${theme.colors.heavyLineOutline}`};
  border-radius: 5px;
  transition: background-color 0.3s;
  cursor: pointer;
  &:hover {
    background-color: ${({ theme }) => theme.colors.lightLineDivider};
  }
`;

export const LineClamp = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  color: ${({ theme }) => theme.colors.primaryText};
`;
